import FileIcon from "@redotech/redo-icons/file-06.svg";
import { BooleanFilterOperator } from "@redotech/redo-model/views/advanced-filters/boolean-filter";
import { AdvancedFilterType } from "@redotech/redo-model/views/advanced-filters/generic-advanced-filter-data";
import { BooleanTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

export const CommercialInvoiceElectronicFilter: BooleanTableFilter = {
  type: AdvancedFilterType.BOOLEAN,
  operators: [BooleanFilterOperator.IS],
  data: {
    name: "commercialInvoiceElectronic",
    type: AdvancedFilterType.BOOLEAN,
    value: true,
    operator: BooleanFilterOperator.IS,
  },
  boolDisplay: {
    falseDisplay: "not submitted electronically",
    trueDisplay: "submitted electronically",
  },
  Icon: FileIcon,
  displayName: "Comm. invoice e-submitted",
  label: "Commercial invoice",
};
